(function () {
  'use strict';

  function resolveLegalClass(variant, product) {
    var v = variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.legal_class;
    if (v) return v;
    var p = product && product.metafields && product.metafields.custom && product.metafields.custom.legal_class;
    if (p) return p;
    return null;
  }

  // PDP-Mapping (entspricht dem Liquid-case in snippet-legal-status-trautis.liquid).
  // 'variiert' + 'ohne_angabe' + Unbekanntes -> kein Badge auf der PDP.
  function classToBadge(lc) {
    switch (lc) {
      case 'eintragungsfrei':      return { label: 'Eintragungsfrei', tone: 'positive' };
      case 'eintragungspflichtig': return { label: 'Eintragungspflichtig', tone: 'caution', reassure: 'mit Gutachten' };
      case 'motorsport':           return { label: 'Nur Motorsport · keine StVO-Zulassung', tone: 'warn' };
      case 'ersatzteil':           return { label: 'Ersatzteil', tone: 'positive' };
      default:                     return null;
    }
  }

  // Reassure-Text nur, wenn die Klasse eine Reassure traegt UND die Variante/das
  // Produkt laut legal_documents wirklich ein Gutachten hat.
  function reassureFor(badge, hasGutachten) {
    return (badge && badge.reassure && hasGutachten) ? badge.reassure : null;
  }

  // legal_class (+ Gutachten) -> Farbe der linken Karten-Schiene. Token: green|gold|red|gray.
  // eintragungspflichtig MIT Gutachten -> green (eintragbar = beruhigend), sonst gold.
  // motorsport -> red (bewusste Ausnahme). variiert/ohne_angabe/unbekannt/null -> gray.
  // Mirror der Liquid-Logik in snippet-legal-rail-trautis.liquid (SSR-Karte).
  var RAIL_TOKENS = ['green', 'gold', 'red', 'gray'];
  function applyBuyboxRail(rootEl, token) {
    if (!rootEl || RAIL_TOKENS.indexOf(token) === -1) return;
    rootEl.classList.remove('t-buybox--rail-green', 't-buybox--rail-gold', 't-buybox--rail-red', 't-buybox--rail-gray');
    rootEl.classList.add('t-buybox--rail-' + token);
  }

  function classToRail(lc, hasGutachten) {
    switch (lc) {
      case 'eintragungsfrei':
      case 'ersatzteil':
        return 'green';
      case 'eintragungspflichtig':
        return hasGutachten ? 'green' : 'gold';
      case 'motorsport':
        return 'red';
      default:
        return 'gray';
    }
  }

  // Welche custom.legal_documents-Werte zaehlen als "mit Gutachten" — Map-Paritaet
  // mit der contains-Liste im Liquid-Snippet (snippet-legal-status-trautis.liquid).
  var GUTACHTEN_TOKENS = ['Teilegutachten', 'Teiletypgenehmigung', 'Kombinationsgutachten', 'Materialgutachten', 'Festigkeitsgutachten'];

  // legal_documents NUR der gewählten Variante — KEIN Produkt-Fallback. Sonst würde
  // eine Variante ohne eigene Nachweise die Produkt-Union zeigen → falsche „mit
  // Gutachten"-Aussage (§5 UWG). Lieber keine Pill als eine falsche.
  function resolveLegalDocs(variant) {
    var v = variant && variant.metafields && variant.metafields.custom ? variant.metafields.custom.legal_documents : null;
    return (v !== null && v !== undefined) ? v : [];
  }

  function docsHaveGutachten(docs) {
    if (!docs || !docs.length) return false;
    for (var i = 0; i < docs.length; i++) {
      if (GUTACHTEN_TOKENS.indexOf(docs[i]) !== -1) return true;
    }
    return false;
  }

  function getProductJSON(root) {
    var s = root.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function bindBadge(root) {
    if (root.dataset.legalBound) return;
    var container = root.querySelector('[data-legal-badges]');
    if (!container) return;
    var pill = container.querySelector('[data-legal-pill]');
    var label = container.querySelector('[data-legal-label]');
    // Optionales zweites "Beruhigungs"-Pill (z. B. "mit Gutachten" bei eintragungspflichtig).
    var reassurePill = container.querySelector('[data-legal-reassure]');
    var reassureLabel = container.querySelector('[data-legal-reassure-label]');
    var product = getProductJSON(root);
    if (!product || !pill || !label) return;
    root.dataset.legalBound = '1';
    root.addEventListener('trautis:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      // Rail spiegelt snippet-legal-rail-trautis.liquid EXAKT (Variante-mit-eigener-legal_class
      // gewinnt inkl. ihrer docs, sonst Produkt-Ebene) → SSR-Klasse und JS-Update divergieren nie.
      var rcust = v && v.metafields && v.metafields.custom;
      var pcust = product && product.metafields && product.metafields.custom;
      var hasVlc = !!(rcust && rcust.legal_class);
      var railLc = (hasVlc ? rcust.legal_class : (pcust && pcust.legal_class)) || '';
      var railDocs = (hasVlc ? rcust.legal_documents : (pcust && pcust.legal_documents)) || [];
      var railEl = root.querySelector('[data-product-form]');
      if (railEl) applyBuyboxRail(railEl, classToRail(String(railLc).toLowerCase(), docsHaveGutachten(railDocs)));
      var badge = v ? classToBadge(resolveLegalClass(v, product)) : null;
      if (badge) {
        label.textContent = badge.label;
        pill.className = 't-pills__pill t-pills__pill--' + badge.tone;
        container.removeAttribute('hidden');
        if (reassurePill) {
          var rtext = reassureFor(badge, docsHaveGutachten(resolveLegalDocs(v)));
          if (rtext) {
            if (reassureLabel) reassureLabel.textContent = rtext;
            reassurePill.className = 't-pills__pill t-pills__pill--positive';
            reassurePill.removeAttribute('hidden');
          } else {
            reassurePill.setAttribute('hidden', '');
          }
        }
      } else {
        container.setAttribute('hidden', '');
        if (reassurePill) reassurePill.setAttribute('hidden', '');
      }
    });
  }

  function init() { document.querySelectorAll('[data-product-section]').forEach(bindBadge); }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  window.TrautisLegalBadge = { resolveLegalClass: resolveLegalClass, classToBadge: classToBadge, reassureFor: reassureFor, resolveLegalDocs: resolveLegalDocs, docsHaveGutachten: docsHaveGutachten, classToRail: classToRail, applyBuyboxRail: applyBuyboxRail };
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisLegalBadge) || {
    resolveLegalClass: function () { return null; },
    classToBadge: function () { return null; },
    reassureFor: function () { return null; },
    resolveLegalDocs: function () { return []; },
    docsHaveGutachten: function () { return false; },
    classToRail: function () { return 'gray'; },
    applyBuyboxRail: function () {}
  };
}
